/** Explicit opt-in for local development and reviewed release channels. */
export function canonicalFeedbackPreviewEnabled(): boolean {
  return import.meta.env.VITE_CANONICAL_FEEDBACK_PREVIEW === '1'
    && (import.meta.env.DEV
      || ['dev', 'main', 'production'].includes(import.meta.env.VITE_TKTIC_RELEASE_CHANNEL ?? ''));
}
